import { createContext, useContext } from "react";

export const AuthContext = createContext({
  username: null,
  role: null, // "admin" | "viewer" | null
  isAdmin: false,
  isViewer: false,
});

export const useAuth = () => useContext(AuthContext);
